var OurpayButtonFormBase = (function (_) {

    var OurpayButtonFormBase = Backbone.View.extend({

        _isOurPayApplicable: false,

        hiddenClass: 'hidden-block',

        template: 'bt-checkout-ourpay',

        container: '#bt-checkout-buttons-current',

        initialize: function (opts) {

            this.currentMode = 1;

            opts.container && (this.container = opts.container);

            opts.current && this.listenTo(opts.current, 'change', _.bind(this._toggle, this));

            opts.packageDetails && this.listenTo(opts.packageDetails, 'change', _.bind(this._toggle, this));

            _.bindAll(this, "_availablePaymentOptionsChanged");
            opts.order._onUpdateCheckout(this._availablePaymentOptionsChanged);

            this.listenTo(this.model, 'update', _.bind(this._toggle, this));

            this._current = opts.current;

            this._packageDetails = opts.packageDetails;

            this._provider = opts.provider;

            this._providers = opts.providers;

            this._service = opts.service;

            this._services = opts.services;

            this.service_3ds = opts.service_3ds;

            // TBD: test classes should be added another way
            this._transactionsTestClassName = opts.testClass && (opts.testClass + 'transactions-wrapper');

            this._render(opts || {});

            this._renderButton(opts.testClass && (opts.testClass + 'button'));

        },

        setCurrentMode: function (mode) {
            this.currentMode = mode;
            this._toggle();
        },

        _availablePaymentOptionsChanged: function () {
            var options = this.options.order.attributes.AvailablePaymentOptions;
            this._isOurPayApplicable = options && _.some(options, function (po) { return po.Name.toLowerCase() === "ourpay".toLowerCase() });
            this._toggle();
        },

        _renderButton: function () {

        },

        isOurPayApplicable: function() {
            return this._isOurPayApplicable;
        },

        setService: function (service) {
            this._service = service;
            this.ourPayButtonView && this.ourPayButtonView.setService(service);
        },

        _render: function () {
            this.$el = $.tmpl(this.template).appendTo($(this.container));

            this._$myPayButton = this.$('@myPayButton');

            this._$myPayStripeButton = this.$('@myPayStripeButton');
        },

        _toggle: function () {
        },

        _hide: function () {
            this.$el.addClass(this.hiddenClass);
        },

        _show: function () {
            var isRejected = this.model.isRejected();
            this.$el.toggleClass(this.hiddenClass, isRejected);
        }
    });

    return OurpayButtonFormBase;
})(_);